import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { authService } from '../../services/authService';
import DropDown from '../GlobalComponents/Dropdown/Dropdown';

interface UserDropdownProps {
  profileImageUrl?: string | null;
  firstName: string;
  lastName: string;
}

const UserDropdown: React.FC<UserDropdownProps> = ({
  profileImageUrl,
  firstName,
  lastName
}) => {
  const navigate = useNavigate();
  const uiData = useSelector((state: RootState) => state.ui);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Get user initials
  const getUserInitials = () => {
    const first = firstName?.[0] || '';
    const last = lastName?.[0] || '';
    return (first + last).toUpperCase() || '??';
  };

  // Generate consistent color from initials
  const getInitialsColor = (initials: string): string => {
    let hash = 0;
    for (let i = 0; i < initials.length; i++) {
      hash = initials.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = hash % 360;
    return `hsl(${hue}, 60%, 50%)`;
  };

  const handleOptionSelect = async (option: string) => {
    if (option === 'Account Settings') {
      navigate('/account');
    } else if (option === 'Sign Out') {
      await authService.signOut();
      window.location.href = '/auth/login';
    }
  };

  const userInitials = getUserInitials();
  const dropdownOptions = ['Account Settings', 'Sign Out'];

  return (
    <div style={{ position: 'relative', height: '100%', aspectRatio: '1/1' }}>
      <DropDown
        options={dropdownOptions}
        onSelect={handleOptionSelect}
        setIsMenuOpen={setIsMenuOpen}
        backgroundColor="rgba(40, 40, 40, 0.95)"
        hoverColor={`rgba(${uiData.schemeColor}, 0.2)`}
        maxWidth="fit-content"
      >
        <div
          style={{
            height: '100%',
            width: '100%',
            borderRadius: '50%',
            overflow: 'hidden',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: profileImageUrl ? 'transparent' : getInitialsColor(userInitials),
            border: `0.2vh solid rgba(${uiData.schemeColor}, 0.5)`,
            fontSize: '1.4vh',
            fontWeight: '600',
            color: 'white',
            transition: 'transform 0.2s ease, border-color 0.2s ease',
            transform: isMenuOpen ? 'scale(1.05)' : 'scale(1)'
          }}
        >
          {profileImageUrl ? (
            <img
              src={profileImageUrl}
              alt="Profile"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          ) : (
            <span>{userInitials}</span>
          )}
        </div>
      </DropDown>
    </div>
  );
};

export default UserDropdown;
